<template>
    <div class="card-block">
      <div class="form-group row">
        <div class="col-md-12">
          <h5>
            <strong>
              <i class="fa fa-university"></i> Informações de Contas
            </strong>
          </h5>
        </div>
      </div>

      <div v-for="contaCorrente in contaCorrenteList" :key="contaCorrente.id + 'ccorr'">
        <strong>Conta Corrente: </strong>
        {{ contaCorrente ? contaCorrente.numeroContaCorrente : '' }}
        <strong>- Status:</strong>
        {{ contaCorrente ? contaCorrente.situacaoContaCorrente : '' }}
      </div>

      <div v-for="matricula in matriculaList" :key="matricula.id + 'ccap'">
        <strong>Matricula: </strong>
        {{ matricula ? matricula.numMatricula : '' }}
        <strong>- Status:</strong>
        {{ matricula ? matricula.situacaoMatricula : '' }}
      </div>
    </div>
  </template>

<script>
export default {
  name: 'AssociateInfosContas',
  props: {
    contaCorrenteList: {
      type: Array,
      required: true
    },
    matriculaList: {
      type: Array,
      required: true
    }
  }
}
</script>

  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateInfosContas.vue